module.exports = __webpack_public_path__ + "static/img/img.512d075.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img.jpg
// module id = +C1k
// module chunks = 21